<template>
<div class="chapter">
<div class="inner_page">
<p class="bktitle"><a id="page_ii"></a><a id="page_iii"></a>The Coffin Roads</p>
<p class="sub"><em>Journeys to the West</em></p>
<p class="author">Ian Bradley</p>
<p class="pub"><img alt="Illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5f436a80